import { handleActions } from 'redux-actions';
import { vehiclesActionsTypes } from './actions';

const initialState = {
  queryAllowListInProgress: false,
  queryAllowListHasFailed: false,
  queryAllowListApiErrors: null,
  allowList: {
    totalElements: 0,
    totalPages: 0,
    number: 0,
    size: 0,
    first: false,
    last: false,
    content: []
  },
  queryBlockListInProgress: false,
  queryBlockListHasFailed: false,
  queryBlockListApiErrors: null,
  addVehicleToAllowListInProgress: false,
  addVehicleToAllowListHasFailed: false,
  addVehicleToAllowListApiErrors: null,
  deleteVehicleFromBlockListInProgress: false,
  deleteVehicleFromBlockListHasFailed: false,
  deleteVehicleFromBlockListApiErrors: null,
  deleteVehicleFromAllowListInProgress: false,
  deleteVehicleFromAllowListHasFailed: false,
  deleteVehicleFromAllowListApiErrors: null,
  blockList: {
    totalElements: 0,
    totalPages: 0,
    number: 0,
    size: 0,
    first: false,
    last: false,
    content: []
  },
  validatePlateInProgress: false,
  validatePlateResult: null,
  residentAccessMatches: null,
  queryResidentAccessMatchesInProgress: false,
  queryResidentAccessMatchesHasFailed: false,
  queryResidentAccessMatchesApiErrors: null,
  accountPlateMatches: {
    totalElements: 0,
    totalPages: 0,
    number: 0,
    size: 20,
    first: true,
    last: true,
    content: []
  },
  queryAccountPlateMatchesInProgress: false,
  queryAccountPlateMatchesHasFailed: false,
  queryAccountPlateMatchesApiErrors: null,
  backfillMatchesInProgress: false,
  backfillMatchesHasFailed: false,
  backfillMatchesApiErrors: null,
  backfillMatchesResult: null
};

/*
example response

{
  "totalElements": 1,
  "totalPages": 1,
  "number": 0,
  "size": 20,
  "first": true,
  "last": true,
  "content": [
    {
      "id": "550e8400-e29b-41d4-a716-446655440000",
      "createdAt": "2024-01-15T10:30:45.123Z",
      "updatedAt": "2024-01-20T14:22:18.456Z",
      "version": 1,
      "licensePlate": "AB123CD",
      "notificationEnabled": true,
      "accessSchedule": {
        "type": "RANGE",
        "validFrom": "2024-01-01T00:00:00Z",
        "validUntil": "2024-01-05T23:59:59Z",
        "cronExpression": "* 9-16 * * *"
      },
      "invitationId": "123e4567-e89b-12d3-a456-426614174000",
      "individualId": 1234567890,
      "individualGroupId": 9876543210,
      "licensePlateVisitorChangesCount": 3,
      "isBlocklisted": false,
      "lastAccessAt": "2024-01-20T08:15:30.789Z"
    }
  ]
}

*/

const reducer = handleActions(
  {
    [vehiclesActionsTypes.deleteVehicleFromBlockListInProgress]: state => {
      return {
        ...state,
        deleteVehicleFromBlockListInProgress: true,
        deleteVehicleFromBlockListHasFailed: false,
        deleteVehicleFromBlockListApiErrors: null
      };
    },
    [vehiclesActionsTypes.deleteVehicleFromBlockListFail]: (state, action) => {
      return {
        ...state,
        deleteVehicleFromBlockListInProgress: false,
        deleteVehicleFromBlockListHasFailed: true,
        deleteVehicleFromBlockListApiErrors: action.payload.apiErrors
      };
    },
    [vehiclesActionsTypes.deleteVehicleFromBlockListSuccess]: state => {
      return {
        ...state,
        deleteVehicleFromBlockListInProgress: false,
        deleteVehicleFromBlockListHasFailed: false,
        deleteVehicleFromBlockListApiErrors: null
      };
    },
    [vehiclesActionsTypes.deleteVehicleFromAllowListInProgress]: state => {
      return {
        ...state,
        deleteVehicleFromAllowListInProgress: true,
        deleteVehicleFromAllowListHasFailed: false,
        deleteVehicleFromAllowListApiErrors: null
      };
    },
    [vehiclesActionsTypes.deleteVehicleFromAllowListFail]: (state, action) => {
      return {
        ...state,
        deleteVehicleFromAllowListInProgress: false,
        deleteVehicleFromAllowListHasFailed: true,
        deleteVehicleFromAllowListApiErrors: action.payload.apiErrors
      };
    },
    [vehiclesActionsTypes.deleteVehicleFromAllowListSuccess]: state => {
      return {
        ...state,
        deleteVehicleFromAllowListInProgress: false,
        deleteVehicleFromAllowListHasFailed: false,
        deleteVehicleFromAllowListApiErrors: null
      };
    },
    [vehiclesActionsTypes.addVehicleToAllowListInProgress]: state => {
      return {
        ...state,
        addVehicleToAllowListInProgress: true,
        addVehicleToAllowListHasFailed: false,
        addVehicleToAllowListApiErrors: null
      };
    },
    [vehiclesActionsTypes.addVehicleToAllowListFail]: (state, action) => {
      return {
        ...state,
        addVehicleToAllowListInProgress: false,
        addVehicleToAllowListHasFailed: true,
        addVehicleToAllowListApiErrors: action.payload.apiErrors
      };
    },
    [vehiclesActionsTypes.addVehicleToAllowListSuccess]: state => {
      return {
        ...state,
        addVehicleToAllowListInProgress: false,
        addVehicleToAllowListHasFailed: false,
        addVehicleToAllowListApiErrors: null
      };
    },
    [vehiclesActionsTypes.queryAllowListInProgress]: state => {
      return {
        ...state,
        queryAllowListInProgress: true,
        queryAllowListHasFailed: false,
        queryAllowListApiErrors: null
      };
    },
    [vehiclesActionsTypes.queryAllowListFail]: (state, action) => {
      return {
        ...state,
        queryAllowListInProgress: false,
        queryAllowListHasFailed: true,
        queryAllowListApiErrors: action.payload.apiErrors,
        allowList: {
          totalElements: 0,
          totalPages: 0,
          number: 0,
          size: 0,
          first: false,
          last: false,
          content: []
        }
      };
    },
    [vehiclesActionsTypes.queryAllowListSuccess]: (state, action) => {
      return {
        ...state,
        queryAllowListInProgress: false,
        queryAllowListHasFailed: false,
        queryAllowListApiErrors: null,
        allowList: action.payload
      };
    },
    [vehiclesActionsTypes.queryBlockListInProgress]: state => {
      return {
        ...state,
        queryBlockListInProgress: true,
        queryBlockListHasFailed: false,
        queryBlockListApiErrors: null
      };
    },
    [vehiclesActionsTypes.queryBlockListFail]: (state, action) => {
      return {
        ...state,
        queryBlockListInProgress: false,
        queryBlockListHasFailed: true,
        queryBlockListApiErrors: action.payload.apiErrors,
        blockList: {
          totalElements: 0,
          totalPages: 0,
          number: 0,
          size: 0,
          first: false,
          last: false,
          content: []
        }
      };
    },
    [vehiclesActionsTypes.queryBlockListSuccess]: (state, action) => {
      return {
        ...state,
        queryBlockListInProgress: false,
        queryBlockListHasFailed: false,
        queryBlockListApiErrors: null,
        blockList: action.payload
      };
    },
    [vehiclesActionsTypes.validatePlateInAllowListInProgress]: state => {
      return {
        ...state,
        validatePlateInProgress: true,
        validatePlateResult: null
      };
    },
    [vehiclesActionsTypes.validatePlateInAllowListSuccess]: (state, action) => {
      return {
        ...state,
        validatePlateInProgress: false,
        validatePlateResult: action.payload
      };
    },
    [vehiclesActionsTypes.validatePlateInAllowListFail]: state => {
      return {
        ...state,
        validatePlateInProgress: false,
        validatePlateResult: null
      };
    },
    [vehiclesActionsTypes.validatePlateInAllowListReset]: state => {
      return {
        ...state,
        validatePlateInProgress: false,
        validatePlateResult: null
      };
    },
    [vehiclesActionsTypes.queryResidentAccessMatchesInProgress]: state => {
      return {
        ...state,
        queryResidentAccessMatchesInProgress: true,
        queryResidentAccessMatchesHasFailed: false,
        queryResidentAccessMatchesApiErrors: null
      };
    },
    [vehiclesActionsTypes.queryResidentAccessMatchesSuccess]: (
      state,
      action
    ) => {
      return {
        ...state,
        queryResidentAccessMatchesInProgress: false,
        queryResidentAccessMatchesHasFailed: false,
        queryResidentAccessMatchesApiErrors: null,
        residentAccessMatches: action.payload
      };
    },
    [vehiclesActionsTypes.queryResidentAccessMatchesFail]: (state, action) => {
      return {
        ...state,
        queryResidentAccessMatchesInProgress: false,
        queryResidentAccessMatchesHasFailed: true,
        queryResidentAccessMatchesApiErrors: action.payload.apiError,
        residentAccessMatches: null
      };
    },
    [vehiclesActionsTypes.queryResidentAccessMatchesReset]: state => {
      return {
        ...state,
        queryResidentAccessMatchesInProgress: false,
        queryResidentAccessMatchesHasFailed: false,
        queryResidentAccessMatchesApiErrors: null,
        residentAccessMatches: null
      };
    },
    [vehiclesActionsTypes.queryAccountPlateMatchesInProgress]: state => {
      return {
        ...state,
        queryAccountPlateMatchesInProgress: true,
        queryAccountPlateMatchesHasFailed: false,
        queryAccountPlateMatchesApiErrors: null
      };
    },
    [vehiclesActionsTypes.queryAccountPlateMatchesSuccess]: (state, action) => {
      return {
        ...state,
        queryAccountPlateMatchesInProgress: false,
        queryAccountPlateMatchesHasFailed: false,
        queryAccountPlateMatchesApiErrors: null,
        accountPlateMatches: action.payload
      };
    },
    [vehiclesActionsTypes.queryAccountPlateMatchesFail]: (state, action) => {
      return {
        ...state,
        queryAccountPlateMatchesInProgress: false,
        queryAccountPlateMatchesHasFailed: true,
        queryAccountPlateMatchesApiErrors:
          action.payload && action.payload.apiError
            ? action.payload.apiError
            : null,
        accountPlateMatches: {
          totalElements: 0,
          totalPages: 0,
          number: 0,
          size: 20,
          first: true,
          last: true,
          content: []
        }
      };
    },
    [vehiclesActionsTypes.queryAccountPlateMatchesReset]: state => {
      return {
        ...state,
        queryAccountPlateMatchesInProgress: false,
        queryAccountPlateMatchesHasFailed: false,
        queryAccountPlateMatchesApiErrors: null,
        accountPlateMatches: {
          totalElements: 0,
          totalPages: 0,
          number: 0,
          size: 20,
          first: true,
          last: true,
          content: []
        }
      };
    },
    [vehiclesActionsTypes.backfillMatchesInProgress]: state => {
      return {
        ...state,
        backfillMatchesInProgress: true,
        backfillMatchesHasFailed: false,
        backfillMatchesApiErrors: null,
        backfillMatchesResult: null
      };
    },
    [vehiclesActionsTypes.backfillMatchesSuccess]: (state, action) => {
      return {
        ...state,
        backfillMatchesInProgress: false,
        backfillMatchesHasFailed: false,
        backfillMatchesApiErrors: null,
        backfillMatchesResult: action.payload
      };
    },
    [vehiclesActionsTypes.backfillMatchesFail]: (state, action) => {
      return {
        ...state,
        backfillMatchesInProgress: false,
        backfillMatchesHasFailed: true,
        backfillMatchesApiErrors: action.payload.apiError,
        backfillMatchesResult: null
      };
    },
    [vehiclesActionsTypes.backfillMatchesReset]: state => {
      return {
        ...state,
        backfillMatchesInProgress: false,
        backfillMatchesHasFailed: false,
        backfillMatchesApiErrors: null,
        backfillMatchesResult: null
      };
    }
  },
  initialState
);

export default reducer;
